import { Injectable } from '@angular/core';
import { T9NS } from './translation.const';
import { E_TRANS_KEYS } from './translation.keys';
import { HelperService } from '../helper.service';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  constructor(
    private HELPER: HelperService,
  ) { }

  getTranslation(key: E_TRANS_KEYS): string {
    const frLoc = this.HELPER.frLoc;
    if (T9NS[frLoc] && T9NS[frLoc][key]) {
      return T9NS[frLoc][key];
    }
    return key;
  }

}
